<template>
  <div>
    <div class="admin__row">
      <button class="admin__button--primary button button--primary" v-if="!creating && !editing && isSuperAdmin" @click="createCategory">Create Category +</button>
    </div>
    <form class="section__content form">
      <fieldset v-if="creating || editing" class="form__group">
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Name of the Category</h1>
            <small class="form__item__description">What should we call it?</small>
          </label>

          <section class="admin__input form__item__input input">
            <input type="text" class="input__field"  v-model="name" />
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Category Description</h1>
            <small class="form__item__description">How do you describe it what does this category contain?</small>
          </label>

          <section class="admin__input form__item__input input">
            <textarea type="text" class="input__field"  v-model="description"></textarea>
          </section>
        </article>
        <article class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">Category Sort Id</h1>
            <small class="form__item__description">This is a number id that sorts the categories when they are displayed on the homepage list. The smaller the number the higher on the list it will appear.</small>
          </label>

          <section class="admin__input form__item__input input">
            <input type="number" class="input__field"  v-model="sort_id">
          </section>
        </article>
      </fieldset>
      <fieldset v-if="editing" class="form__group">
        <article class="form__item form__item">
          <label class="form__item__label">
            <h1 class="form__item__name">Ads in Category</h1>
            <small class="form__item__description">Which ads are in this category?</small>
          </label>

          <section class="admin__input form__item__input input">
            <input type="text" class="input__field" placeholder="Search..."  v-model="adSearch" />
            <div id="admin__category__ul">
              <div v-for="format in filterFormats">
                <a @click="adSearch = format.name" class="admin__li" v-if="format.name.toUpperCase().indexOf(adSearch.toUpperCase()) > -1 && format.name !== adSearch" href="#">{{ format.name }}</a>
              </div>
            </div>
          </section>
          <section class="admin__input form__item__input">
            <div @click="addFormat" class="admin__button--primary button button--primary">Add Format</div>
          </section>
        </article>
        <article v-for="ad in formatslist" class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">{{ ad.name }}</h1>
          </label>
          <section class="admin__input form__item__input input">
            <div @click="deleteFormat(ad.id)" class="admin__button button button--remove">Remove</div>
          </section>
        </article>
      </fieldset>
      <fieldset v-if="editing || creating" class="form__group">
        <article class="form__item form__item--show-border">
          <a href="#" v-on:click.prevent="saveCategory" class="admin__button--primary section__footer__button button button--primary">Save</a>
          <a href="#" v-on:click.prevent="cancelCategory" class="admin__button section__footer__button section__footer__button--right button button--secondary">Cancel</a>
          <a href="#" v-if="editing && isSuperAdmin " v-on:click.prevent="deleteCategory" class="admin__button section__footer__button section__footer__button--right button button--remove">Delete Category</a>
        </article>
      </fieldset>
      <fieldset v-if="!editing && !creating" class="form__group">
        <h1 class="admin__title">Categories ({{ categories.length }})</h1>
        <article @click="editCategory(item)" v-for="item in categories" class="admin__form form__item form__item--show-border">
          <h2>{{ item.name }}</h2>
        </article>
      </fieldset>
    </form>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'AdminCategories',
    methods: {
      createCategory () {
        this.creating = true;
        return null
      },
      editCategory (item) {
        this.editId = item.id;
        this.name = item.name;
        this.description = item.description;
        this.formatslist = item.formats;
        this.editing = true;
        this.sort_id = item.sort;
        return null
      },
      deleteCategory () {
        this.$modal.show('warning', {
          messageText: 'Are you sure you want to delete the selected category?',
          buttonText: 'Delete Category',
          callback: function (params) {
            this.$store.dispatch('categories/delete', this.editId);
            this.cancelCategory();
          }.bind(this)
        })
      },
      saveCategory () {
        let payload = {
          name: this.name,
          description: this.description,
          sort: this.sort_id
        };
        let cat = this;
        if (this.creating && !this.editing) {
          this.$store.dispatch('categories/create', {data: payload,
            callback: function (response) {
              cat.cancelCategory()
            }}, this.$snotify);
        } else if (this.editing && !this.creating) {
          this.$store.dispatch('categories/update', {id: this.editId, category: payload, callback: (response)=>{cat.cancelCategory();}}, this.$snotify);

          if (this.formatsToDelete.length > 0) {
            this.formatsToDelete.forEach(id => {
              this.categoryFormats.forEach(cf => {
                if (cf.category_id === this.editId && cf.format_id === id) {
                  cat.$store.dispatch('categories/formats/delete', cf.id);
                }
              });
            })
          }
          if (this.formatsToAdd.length > 0) {
            this.formatsToAdd.forEach(id => {
              cat.$store.dispatch('categories/formats/add', {category_id: this.editId, format_id: id});
            })
          }
        }
      },
      cancelCategory () {
        this.name = '';
        this.description = '';
        this.sort_id = '';

        if (this.editing) {
          this.editing = false;
          this.formatsToAdd = [];
          this.formatsToDelete = [];
        } else if (this.creating) {
          this.creating = false;
        }
        return null
      },
      addFormat () {
        let ad = this.adSearch;
        this.getFormats().forEach(format => {
          if (format.name === ad) {
            this.formatslist.unshift(format);
            this.formatsToAdd.push(format.id);
          }
        });
        this.adSearch = '';
        return null
      },
      deleteFormat (id) {
        for (var i = 0; i < this.formatslist.length; i++) {
          if (this.formatslist[i].id === id) {
            this.formatslist.splice(i, 1);
            this.formatsToDelete.push(id)
          }
        }
      },
      getFormats () {
        return this.$store.getters['formats/formats'];
      },
    },
    computed: {
      ...mapState('categories', ['categories']),
      ...mapState('categories/formats', ['categoryFormats']),
      isSuperAdmin() {
        return this.$store.state.me.admin
      },
      filterFormats () {
        let rtnArray = [];
        let adsArray = [];
        this.formatslist.forEach(format => {
          adsArray.push(format.name)
        })
        this.getFormats().forEach(ad => {
          if (!(adsArray.indexOf(ad.name) > -1)) {
            rtnArray.push(ad);
          }
        });
        return rtnArray
      }
    },
    data () {
      return {
        creating: false,
        name: '',
        description: '',
        editing: false,
        editId: 0,
        adSearch: '',
        formatslist: {},
        formatsToDelete: [],
        formatsToAdd: [],
        sort_id: 0
      }
    }
  }
</script>

<style scoped>

  .admin__input {
  }

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminCategories.vue